'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMockChatHistory = getMockChatHistory;
exports.getMockConversation = getMockConversation;

var _immutable = require('immutable');

var _Visitor = require('conversations-core/data/records/Visitor');

var _Visitor2 = _interopRequireDefault(_Visitor);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _PubNubMessageFactory = require('conversations-schema/factories/PubNubMessageFactory');

var _ChatHistory = require('conversations-schema/records/ChatHistory');

var _ChatHistory2 = _interopRequireDefault(_ChatHistory);

var _Conversation = require('conversations-schema/records/Conversation');

var _Conversation2 = _interopRequireDefault(_Conversation);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getMockChatHistory(firstMessage) {
  var _metadata, _metadata2;

  var text = !firstMessage ? _I18n2.default.text('default.repText') : firstMessage;
  return (0, _ChatHistory2.default)({
    history: (0, _immutable.fromJS)([(0, _PubNubMessageFactory.buildPublishedMessage)({
      metadata: (_metadata = {}, _defineProperty(_metadata, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.CHAT_MESSAGE), _defineProperty(_metadata, 'text', text), _defineProperty(_metadata, 'from', _RoleTypes2.default.REP), _metadata),
      timestamp: _I18n2.default.moment().valueOf()
    }), (0, _PubNubMessageFactory.buildPublishedMessage)({
      metadata: (_metadata2 = {}, _defineProperty(_metadata2, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.CHAT_MESSAGE), _defineProperty(_metadata2, 'text', _I18n2.default.text('default.visitorText')), _defineProperty(_metadata2, 'from', _RoleTypes2.default.VISITOR), _metadata2),
      timestamp: _I18n2.default.moment().valueOf()
    })]).toOrderedSet()
  });
}

function getMockConversation(firstMessage) {
  return (0, _Conversation2.default)({
    portalId: _hubspot2.default.get(),
    visitor: (0, _Visitor2.default)(),
    chatHistory: getMockChatHistory(firstMessage)
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/factories/ConversationFactory.js
// module id = 290
// module chunks = 0 1